export default "__VITE_ASSET__$onRdxiF__"